<input-information>
  <style>
  p.footer_ext {
    padding-top: 1.5em;
    padding-bottom: 1.5em;
    font-weight: bold
  }
  p.footer_ext a {
    color: blue;
  }
  </style>

  <section class="sec-top-function com-bg-gray">
    <div class="sec-top-inner sec-inner">
      <header class="sec-top-header">
        <h2 class="sec-top__ttl"><span>本登録（確認画面）</span></h2>
        <p>
          下記の内容で誤りがないかをご確認ください。
        </p>
      </header>
    </div>
  </section>

  <div class="com-article-inner">
    <div class="sec-inner">
      <div class="sec-basic-input__wrap com-bg-white">
        <section class="sec-basic-input">
          <div class="com-form">
            <form>
              <div class="com-form__item">
                <p class="com-form__item__caption"><span>メールアドレス</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text">
                    {mail}
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>名前</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text short">
                    {coreData["familyName"]} {coreData["firstName"]}
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>フリガナ</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text short">
                    {coreData["familyKana"]} {coreData["firstKana"]}
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>性別</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input">
                    {sexList[coreData.sex]}
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>生年月日</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input">
                    <span>{coreData.birthYear}年</span>
                    <span>{coreData.birthMonth}月</span>
                    <span>{coreData.birthDay}日</span>
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>居住地</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input">
                    { getPrefectureName(coreData.pref) }
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>ログインパスワード</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text">
                    {''.padStart(coreData.password.length, '*')}
                  </div>
                </div>
              </div>

              <p class="footer_ext">
                本サービスのご利用には「<a href="/rules" target="_blank">edireco利用規約</a>」とCROCO株式会社の「<a href="https://cro-co.co.jp/privacypolicy/agreement/" target="_blank">個人情報の取扱</a>」に同意していただく必要があります
              </p>
                  
              <div class="com-form__item__content" style="padding-bottom: 1.5em">
                <div class="com-form__item__input input-checkbox">
                  <input id="edireco_agreement_checkbox" type="checkbox" name="edireco" is="edireco-binding" data="{agreeData}" val="1" required errMsg="内容を確認して同意する場合はチェックを付けてください" />
                  <label for="edireco_agreement_checkbox" style="font-weight: bold">edirecoの利用規約に同意します</label>
                </div>
              </div>
              <div class="com-form__item__content">
                <div class="com-form__item__input input-checkbox">
                  <input id="privacy_agreement_checkbox" type="checkbox" name="privacy" is="edireco-binding" data="{agreeData}" val="1" required errMsg="内容を確認して同意する場合はチェックを付けてください" />
                  <label for="privacy_agreement_checkbox" style="font-weight: bold">個人情報の取扱に同意します</label>
                </div>
              </div>

              <div class="com-form__submit">
                <a class="com-btn-back-01" onclick="{back}" if={!isLoading}><span>戻る</span></a>
                <button type="button" class="com-btn-01" onclick="{dump}" if={!isLoading}><span>会員登録完了</span></button>
              </div>
            </form>

          </div>

        </section>
        <!-- End .sec-basic-input -->
      </div>
    </div>
  </div>

  <script>
    import di from 'dependeny-injection'

    export default {
      mail: di.register.masked_mail,
      coreData: {password: ''},
      agreeData: di.register.agreeData,
      sexList: di.register.sexList,
      isLoading: false,
      onMounted() {
        scrollTo(0, 0);
        if (di.register.secondCode === false) {
          di.route.router.push("/confirm-code");
          return;
        }
        this.mail = di.register.masked_mail;
        this.coreData = di.register.coreData.toData();
        this.update();
      },
      back(e) {
        e.preventDefault();
        di.route.router.push("/input-information");
      },
      dump(e) {
        e.preventDefault();
        if (!this.agreeData.validate()) {
          return;
        }
        di.register.changeLoaderState(true, this, 'isLoading');
        let data = di.register.coreData.toData();
        data.secondCode = di.register.secondCode;
        di.register.api('/execute', data)
          .then((data) => {
            di.register.changeLoaderState(false, this, 'isLoading');
            if (data.status) {
                di.register.unlockUnload();
                location.href = data.location;
            } else {
                alert(data.message);
            }
        });
      },
      getPrefectureName(id) {
        if (id == 48) {
          return this.coreData.country;
        }
        for (const pref of window.__PREF_MASTERS__) {
          if (pref.id==id) {
            return pref.jname
          }
        }
      },
    }
  </script>
</input-information>